import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import RangeSlider from 'react-range-slider-input'
import 'react-range-slider-input/dist/style.css'
import styled from 'styled-components'
import cloneDeep from 'clone-deep' // needed when resetting state
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import ExpandableSections from '../ui/ExpandableFilters'
import { withSearch } from '../SearchContext'
import Switch from 'react-switch'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment/moment'
import {
  objectToQueryString,
  paramsToObject,
  strLimit,
} from '../../utils/utils'
import { withAuth } from '../AuthContext'
import { textTranslation, shouldTranslateTo } from '../../utils/utils'
import { decode } from 'html-entities'
import { useMediaQuery } from 'react-responsive'
import { Spinner } from 'react-bootstrap'
import 'bootstrap-daterangepicker/daterangepicker.css'

const RangeSliderContainer = styled.div`
  .input-range__track--active,
  .input-range__slider {
    background: ${(props) => props.color};
    border-color: ${(props) => props.color};
  }
`

const DatePickerButton = styled.div`
  background: #f5f6f7;
  border: none;
  width: 100%;
  height: 52px;
  padding: 0 5px;
  text-overflow: ellipsis;
  cursor: pointer;
  text-align: center;
  line-height: 52px;
`

const DisabledDatePickerButton = styled(DatePickerButton)`
  background-color: #ccc;
  color: #666;
  cursor: default;
`

class Listings extends Component {
  constructor() {
    super()
    // TODO Filter state stored here, could be moved to SearchContext
    this.state = {
      countries: [],
      totalResults: [],
      results: [], // on current page
      resultsToTranslate: [],
      resultsTranslated: [],
      filters: [],
      filterOptions: [],
      filtersOriginal: [], // used for reset
      filterOptionsOriginal: [], // used for reset
      minPrice: 20, // limit
      maxPrice: 100, // limit
      sortLow: true, // true: low to high, false: high to low
      priceValue: [20, 100], // slider state
      seeking: 'locals',
      country: null,
      activeCategory: null,
      selectedFilters: [],
      selectedCountry: null,
      selectedCity: null,
      loading: false,
      type: 'locals',
      pagination: {},
      flexible: false,
      listingsData: null,
      urlFilters: null,
      isLoggedIn: false,
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleCity = this.handleCity.bind(this)
    this.handleCountry = this.handleCountry.bind(this)
    this.handleSort = this.handleSort.bind(this)
    this.resetFilters = this.resetFilters.bind(this)
    this.handleSwitchChange = this.handleSwitchChange.bind(this)
    this.handleSetSeeking = this.handleSetSeeking.bind(this)
    this.handlePrice = this.handlePrice.bind(this)
    this.getResults = this.getResults.bind(this)
    this.addQuery = this.addQuery.bind(this)
    this.removeQuery = this.removeQuery.bind(this)
    this.handleApply = this.handleApply.bind(this)
    this.getCountries = this.getCountries.bind(this)
  }

  async componentDidMount() {
    this.setState({ seeking: 'locals', loading: true })
    this.setState({ seeking: 'locals', loading: false })
    let query = new URLSearchParams(this.props.location.search)
    const seeking = query.get('seeking')

    let { loggedIn } = this.props.auth
    this.setState({
      isLoggedIn: loggedIn,
    })

    if (seeking === 'locals' || seeking === 'homestays') {
      this.setState({
        seeking: seeking,
      })
    }

    const country = query.get('country')
    if (country) {
      this.setState({
        country,
      })
    }

    const city = query.get('city')
    if (city) {
      this.setState({
        city,
      })
    }

    const min = query.get('minPrice')
    const max = query.get('maxPrice')
    if (min && max) {
      this.setState({
        priceValue: [min, max],
      })
    }

    const start = query.get('startDate')
    const end = query.get('endDate')

    if (start && end) {
      const parsedStartDate = moment(start, 'DD-MM-YYYY', true)
      const parsedEndDate = moment(end, 'DD-MM-YYYY', true)
      this.setState({
        startDate: parsedStartDate.isValid() ? parsedStartDate : moment(),
        endDate: parsedEndDate.isValid()
          ? parsedEndDate
          : moment().add(1, 'day'),
        dates: {
          label: `${parsedStartDate.format('DD MMM YYYY')} - ${parsedEndDate.format(
            'DD MMM YYYY'
          )}`,
          value: '',
        },
      })
    } else {
      this.setState({
        dates: {
          label: `${moment().format('DD MMM YYYY')} - ${moment()
            .add(30, 'days')
            .format('DD MMM YYYY')}`,
          value: '',
        },
      })
    }

    const flexible = query.get('flexible')
    if (flexible) {
      this.setState({
        flexible: flexible == 'true',
      })
    }

    const filters = query.get('filters')
    let filterValues = []
    if (filters) {
      filterValues = filters.split('-')
      filterValues = filterValues.map((val) => parseInt(val))
      this.setState({
        selectedFilters: filterValues,
      })
    }

    axios
      .get('/api/filters')
      .then((response) => {
        const filters = response.data.map((filterCategory) => {
          let category = {}
          category.options = filterCategory.fbc_core_filter_options.map(
            (filterOption) => {
              let option = {}
              option.selected = filterValues.indexOf(filterOption.id) > -1
              option.name = filterOption.filterOption
              option.id = filterOption.id
              return option
            }
          )
          category.id = filterCategory.id
          category.name = filterCategory.display
          category.selected = false
          return category
        })
        this.setState({
          filters,
        })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })

    let response = await axios.get(`/api/available-countries?type=${seeking}`)

    let countries = response.data
    countries = countries.map((country) => {
      return { label: country.nicename, value: country.id }
    })
    this.setState({ countries })

    if (country) {
      const selectedCountry = countries.find((x) => x.value == country)
      this.setState({ selectedCountry })
      axios
        .get(`/api/available-cities/${country}?type=${seeking}`)
        .then((response) => {
          let cities = response.data.map((city) => {
            return { label: city.city, value: city.id }
          })
          this.setState({ cities })

          if (city) {
            const selectedCity = cities.find((x) => x.value == city)
            if (selectedCity) {
              this.setState({ selectedCity })
            } else {
              this.removeQuery('city')
            }
          }
        })
        .catch(function (error) {
          console.log('Request failure: ', error)
        })
    }
    await this.getResults()

    this.setState({ loading: false })

    if (this.state.results > 0) {
      const maxPrice = this.state.results.reduce(
        (max, p) => (p.hostPrice > max ? p.hostPrice : max),
        this.state.results[0].hostPrice
      )
      const minPrice = this.state.results.reduce(
        (min, p) => (p.hostPrice < min ? p.hostPrice : min),
        this.state.results[0].hostPrice
      )

      this.setState({
        minPrice: minPrice,
        maxPrice: maxPrice,
        priceValue: [minPrice, maxPrice],
      })
    }

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })
          this.setState({
            listingsData: pageText,
          })
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('listings', language)

    let searchParams = new URLSearchParams(window.location.search)
    this.setState({ urlFilters: searchParams.toString() })
  }

  getCountries(seeking) {
    axios
      .get(`/api/available-countries?type=${seeking}`)
      .then((response) => {
        let countries = response.data
        countries = countries.map((country) => {
          return { label: country.nicename, value: country.id }
        })
        this.setState({ countries })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })
  }

  handleFiltersChange = (updatedFilters) => {
    console.log('Received Updated Filters:', updatedFilters) // Debug

    const selectedFilters = updatedFilters.flatMap((section) =>
      section.options
        .filter((option) => option.selected)
        .map((option) => option.id)
    )

    console.log('Selected Filters:', selectedFilters) // Debug

    this.setState({ filters: updatedFilters, selectedFilters })

    const queryFilters = selectedFilters.join('-')
    console.log('Query Filters:', queryFilters) // Debug

    if (queryFilters.length > 0) {
      this.addQuery('filters', queryFilters)
    } else {
      this.removeQuery('filters')
    }

    setTimeout(() => {
      this.getResults()
    }, 1000)
  }

  toggleCategory = (id) => {
    this.setState((prevState) => ({
      activeCategory: prevState.activeCategory === id ? null : id,
    }))
  }

  async getResults() {
    this.setState({ loading: true })
    const search = window.location.search
    const params = new URLSearchParams(search)
    try {
      let response = null
      if (params.get('seeking') === 'locals') {
        response = await axios.get('/api/search/locals', { params })
      } else {
        response = await axios.get('/api/search/homestays', { params })
      }
      const { data } = response
      this.setState({
        type: this.state.seeking,
        results: data.data,
        totalResults: data.total,
        pagination: {
          current_page: data.current_page,
          first_page_url: data.first_page_url,
          last_page: data.last_page,
          next_page_url: data.next_page_url,
          per_page: data.per_page,
          prev_page_url: data.prev_page_url,
          to: data.to,
          total: data.total,
        },
      })

      let toTranslateArr = []
      if (params.get('seeking') === 'locals') {
        toTranslateArr = data.data.map(function (item) {
          return [
            item.introduction,
            item.country.nicename,
            item.is_host === true ? "I'm a host" : "I'm a local",
          ]
        })
      } else {
        toTranslateArr = data.data.map(function (item) {
          return [
            item.locationDescription,
            item.fbc_core_user.country.nicename,
            item.fbc_core_user.is_host === true ? "I'm a host" : "I'm a local",
          ]
        })
      }
      this.setState({
        resultsToTranslate: toTranslateArr,
      })
    } catch (e) {
      console.log('error', e)
    } finally {
      this.setState({ loading: false })
    }
  }

  handleCity(selectedValue) {
    this.removeQuery('page')
    if (selectedValue) {
      this.setState({ selectedCity: selectedValue })
      this.addQuery('city', selectedValue.value)
    } else {
      this.setState({ selectedCity: null })
      this.removeQuery('city')
    }

    const that = this
    setTimeout(function () {
      that.getResults()
    }, 1000)
  }

  handleCountry(selectedValue) {
    this.removeQuery('page')
    if (selectedValue) {
      const countryId = selectedValue.value
      this.setState({ selectedCountry: selectedValue })
      if (selectedValue) {
        this.removeQuery('city')
        this.setState({ selectedCity: null })
        console.log(
          `/api/available-cities/${countryId}?type=${this.state.seeking}`
        )
        axios
          .get(`/api/available-cities/${countryId}?type=${this.state.seeking}`)
          .then((response) => {
            let cities = response.data.map((city) => {
              return { label: city.city, value: city.id }
            })
            this.setState({ cities })
          })
          .catch(function (error) {
            console.log('Request failure: ', error)
          })
      }
      this.addQuery('country', countryId)
    } else {
      this.removeQuery('city')
      this.removeQuery('country')
      this.setState({ selectedCity: null, selectedCountry: null })
    }

    const that = this
    setTimeout(function () {
      that.getResults()
    }, 1000)
  }

  handleSort({ target }) {
    this.setState({ sortLow: target.value === 'low_high' })
  }

  handleChange(event) {
    this.removeQuery('page')
    const filterId = parseInt(event.target.value)
    let selectedFilters = this.state.selectedFilters
    const index = selectedFilters.indexOf(filterId)
    if (index > -1) {
      selectedFilters.splice(index, 1)
    } else {
      selectedFilters.push(filterId)
    }

    this.setState({ selectedFilters })

    const newFilters = this.state.filters.map((category) => {
      category.options = category.options.map((option) => {
        option.selected = selectedFilters.indexOf(option.id) > -1
        return option
      })
      return category
    })

    this.setState({ filters: newFilters })

    const queryFilters = selectedFilters.join('-')
    this.addQuery('filters', queryFilters)

    const that = this
    setTimeout(function () {
      that.getResults()
    }, 1000)
  }

  resetFilters() {
    this.setState((prevState) => {
      return {
        filters: cloneDeep(this.state.filtersOriginal),
        filterOptions: cloneDeep(this.state.filterOptionsOriginal),
      }
    })
  }

  handleSwitchChange(flexible) {
    this.removeQuery('page')
    this.setState({ flexible })
    this.addQuery('flexible', flexible)
    if (flexible) {
      this.removeQuery('startDate')
      this.removeQuery('endDate')
    }

    const that = this
    setTimeout(function () {
      that.getResults()
    }, 1000)
  }

  handleSetSeeking(value) {
    this.removeQuery('page')
    this.removeQuery('city')
    this.removeQuery('country')
    this.setState({ country: null })
    this.setState({ selectedCity: null })
    this.setState({ selectedCountry: null })
    this.setState({ seeking: value })
    this.setState({ countries: [] })
    this.setState({ cities: [] })
    this.addQuery('seeking', value)

    if (value === 'locals') {
      this.removeQuery('startDate')
      this.removeQuery('endDate')
      this.removeQuery('minPrice')
      this.removeQuery('maxPrice')
      this.removeQuery('filters')
    }

    this.getCountries(value)

    const that = this
    setTimeout(function () {
      that.getResults()
    }, 1000)
  }

  handlePrice(priceValue) {
    this.removeQuery('page')
    this.setState({
      priceValue: priceValue,
    })
    this.addQuery('minPrice', priceValue[0])
    this.addQuery('maxPrice', priceValue[1])

    const that = this
    setTimeout(function () {
      that.getResults()
    }, 1000)
  }

  addQuery(key, value) {
    let searchParams = new URLSearchParams(window.location.search)
    searchParams.set(key, value)

    const queryString = searchParams.toString()
    const newUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      (queryString ? `?${queryString}` : '')

    this.setState({ urlFilters: queryString }, () => {
      this.getResults() // Call getResults after state update
    })
    window.history.pushState({ path: newUrl }, '', newUrl)
  }

  removeQuery(key) {
    let searchParams = new URLSearchParams(window.location.search)
    searchParams.delete(key)

    const queryString = searchParams.toString()
    const newUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      (queryString ? `?${queryString}` : '')

    this.setState({ urlFilters: queryString }, () => {
      this.getResults() // Call getResults after state update
    })
    window.history.pushState({ path: newUrl }, '', newUrl)
  }

  handleApply(e, picker) {
    const startDate = picker.startDate.startOf('day')
    const endDate = picker.endDate.startOf('day')
    const today = moment().startOf('day')

    // Validate dates
    if (!startDate || !endDate) {
      alert('Please select valid dates.')
      return
    }

    if (startDate.isSameOrAfter(endDate)) {
      alert('The end date must be after the start date.')
      return
    }

    if (startDate.isBefore(today) || endDate.isBefore(today)) {
      alert('Dates cannot be in the past.')
      return
    }

    this.setState({ startDate: picker.startDate })
    this.setState({ endDate: picker.endDate })
    this.addQuery('startDate', picker.startDate.format('DD-MM-YYYY'))
    this.addQuery('endDate', picker.endDate.format('DD-MM-YYYY'))

    this.setState({
      dates: {
        label: `${picker.startDate.format(
          'DD MMM YYYY'
        )} - ${picker.endDate.format('DD MMM YYYY')}`,
        value: '',
      },
    })

    const that = this
    setTimeout(function () {
      that.getResults()
    }, 1000)
  }

  render() {
    const { listingsData } = this.state

    const auth = this.props.auth.user
    let results = []
    let translatedResults =
      this.state.resultsTranslated.length > 0 ? true : false
    var resultsTally = 0
    if (this.state.type === 'homestays') {
      let places = this.state.results
      places.forEach((place) => {
        const user = place.fbc_core_user
        const location = `${
          user.city_location ? user.city_location.city : user.city
        }, ${user.country?.nicename || 'Unknown Country'}`
        results.push(
          <ResultCard
            id={place.id}
            price={place.hostPrice}
            hostname={user.forename}
            description={strLimit(place.placeDescription, 200)}
            placePhoto={place.placePhotoL}
            key={place.id}
            location={location}
            startDate={moment(this.state.startDate).format('DD-MM-YYYY')}
            endDate={moment(this.state.endDate).format('DD-MM-YYYY')}
            filters={this.state.urlFilters}
          />
        )
      })
    } else {
      let users = this.state.results
      users.forEach(function (user) {
        const location = auth
          ? `${
              user.city_location ? user.city_location.city : user.city
            }, ${user.country ? user.country.nicename : user.county}`
          : `${user.country ? user.country.nicename : user.county}`
        results.push(
          <ResultUserCard
            userPhoto={user.profilePhotoL}
            userName={user.forename}
            location={location}
            introduction={strLimit(user.introduction, 103)}
            id={user.id}
            key={user.id}
            isHost={user.is_host}
            auth={auth}
          />
        )
      })
    }

    if (!listingsData) {
      return (
        <div style={{ textAlign: 'center' }}>
          <Spinner animation="border" role="status" className="me-2" />
          <p>Loading data...</p>
        </div>
      )
    }

    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: '#f5f6f7',
        border: 'none',
        borderRadius: '0px',
        flexWrap: 'nowrap',
        height: '52px',
      }),
    }

    return (
      <section id="packages_grid_items" className="packages tours_grid">
        <div className="row member_search">
          <div className="container-listing filters d-sm-block d-md-flex">
            <div className="col-12 col-md-4 col-lg-3 seeking-block">
              <ul className="nav nav-pills d-flex">
                <li className="nav-item">
                  <button
                    className={
                      this.state.seeking === 'locals'
                        ? 'nav-link active'
                        : 'nav-link'
                    }
                    onClick={() => this.handleSetSeeking('locals')}
                    disabled={this.state.loading}
                  >
                    {decode(this.state.listingsData[2])}
                  </button>
                </li>
                {this.state.isLoggedIn && (
                  <li className="nav-item">
                    <button
                      className={
                        this.state.seeking === 'homestays'
                          ? 'nav-link active'
                          : 'nav-link'
                      }
                      onClick={() => this.handleSetSeeking('homestays')}
                      disabled={this.state.loading}
                    >
                      {decode(this.state.listingsData[3])}
                    </button>
                  </li>
                )}
              </ul>

              <div className="card">
                <hr style={{ marginTop: '40px' }} />
                <div className="card-body">
                  <div className="">
                    <label>{decode(this.state.listingsData[4])}</label>
                    <div className="form-single pb-3">
                      <Select
                        placeholder={decode(this.state.listingsData[5])}
                        defaultValue={''}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={true}
                        name="country"
                        options={this.state.countries}
                        onChange={this.handleCountry}
                        value={this.state.selectedCountry}
                      />
                    </div>
                    <div className="form-single">
                      <Select
                        placeholder={decode(this.state.listingsData[6])}
                        defaultValue={''}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={true}
                        name="country"
                        options={this.state.cities}
                        onChange={this.handleCity}
                        value={this.state.selectedCity}
                      />
                    </div>
                  </div>
                  <hr />
                  {this.state.seeking === 'homestays' && (
                    <div>
                      <div className="price-range">
                        <h3 className="title-sec">
                          {decode(this.state.listingsData[7])}
                        </h3>
                        <RangeSliderContainer color="#3f77fa">
                          <RangeSlider
                            min={this.state.minPrice}
                            max={this.state.maxPrice}
                            defaultValue={this.state.priceValue}
                            value={this.state.priceValue}
                            step={5}
                            onInput={(priceValue) =>
                              this.handlePrice(priceValue)
                            }
                          />
                        </RangeSliderContainer>
                        <div className="range d-flex justify-content-between">
                          <small className="min pull-left">
                            {decode(this.state.listingsData[8])}
                            <span className="range-label range-label__min">
                              €{this.state.priceValue[0]}
                            </span>
                          </small>
                          <small className="max pull-right">
                            <span className="range-label range-label__max">
                              €{this.state.priceValue[1]}
                            </span>
                            {decode(this.state.listingsData[9])}
                          </small>
                        </div>
                      </div>
                      <hr />
                      <div className="form-single">
                        <div className="d-flex justify-content-between">
                          <div>
                            <label>{decode(this.state.listingsData[10])}</label>
                          </div>
                          <div className="form-single pb-3 float-right filter-switch">
                            <span>{decode(this.state.listingsData[11])}</span>
                            <Switch
                              checked={this.state.flexible}
                              onChange={this.handleSwitchChange}
                              onColor="#0081a7"
                              onHandleColor="#43bbe0"
                              handleDiameter={22}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={48}
                              className="react-switch"
                              id="material-switch"
                            />
                          </div>
                        </div>
                        <div className="form-single pb-3">
                          {this.state.flexible ? (
                            <DisabledDatePickerButton>
                              {this.state.dates.label}
                            </DisabledDatePickerButton>
                          ) : (
                            <DateRangePicker
                              initialSettings={{
                                startDate: this.state.startDate
                                  ? moment(this.state.startDate, 'DD-MM-YYYY')
                                  : moment(new Date(), 'DD-MM-YYYY', true),
                                endDate: this.state.endDate
                                  ? moment(this.state.endDate, 'DD-MM-YYYY')
                                  : moment(new Date(), 'DD-MM-YYYY', true),
                                minDate: moment(new Date(), 'DD-MM-YYYY', true),
                              }}
                              onApply={this.handleApply}
                            >
                              <DatePickerButton>
                                {this.state.dates.label}
                              </DatePickerButton>
                            </DateRangePicker>
                          )}
                        </div>
                      </div>
                      <hr style={{ marginBottom: 0 }} />
                      {this.state.filters && this.state.filters.length > 0 && (
                        <ExpandableSections
                          filters={this.state.filters}
                          onFiltersChange={this.handleFiltersChange}
                        />
                      )}
                      <hr style={{ marginBottom: 20 }} />
                      <div style={{ textAlign: 'center' }}>
                        <Link
                          id="lnk-footer-login"
                          to="/homestay-safety-tips"
                          className="font-open-sans font-weight-300 font-size-18"
                          style={{
                            color: '#929292',
                            textDecoration: 'none',
                            fontWeight: 400,
                          }}
                        >
                          Homestay safety tips
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 col-md-8 col-lg-9 px-md-0">
              <div
                className="card px-0 border-0 mb-md-5"
                style={{ width: '100%' }}
              >
                {this.state.seeking == 'homestays' ? (
                  <div className="beta-badge-corner">BETA</div>
                ) : null}
                <div className="card-body text-center">
                  <h5 className="font-all-round font-weight-600 font-size-30">
                    {decode(this.state.listingsData[0])}
                  </h5>
                  <p className="card-text font-open-sans font-weight-400 font-size-18">
                    {decode(this.state.listingsData[1])}
                  </p>
                </div>
              </div>

              <div className="row custom-row">{results}</div>
              <ResultsPagination
                pagination={this.state.pagination}
                loading={this.state.loading}
                listingsData={this.state.listingsData}
              />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const ResultCard = (props) => {
  const startDateSelected = props.startDate || ''
  const endDateSelected = props.endDate || ''

  const isSpecialCaseOne = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  const isSpecialCaseTwo = useMediaQuery({ maxWidth: 400 })
  return (
    <div className="card card-user mb-3 mx-3 pb-3">
      <div className="card-body">
        <div className="d-flex no-gutters">
          {isSpecialCaseOne || isSpecialCaseTwo ? (
            <Fragment>
              <div className="col-12">
                <div className="row">
                  <div className="col-12 card-user-image-container">
                    <div className="card-img-box card-img-box__special">
                      <img src={s3AwsEndpoint + '/' + props.placePhoto} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="my-3">
                      <h5 className="card-title card-user-title m-0">
                        <Link
                          to={{
                            pathname: `/place/${props.id}`,
                            search: `?startDate=${startDateSelected}&endDate=${endDateSelected}`,
                            state: {
                              filters: props.filters,
                            },
                          }}
                        >
                          {`${props.hostname}'s place`}
                        </Link>
                      </h5>
                      <p className="font-size-16 m-0">
                        <img src="/images/icons/location.svg" alt="" />{' '}
                        {props.location}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="col-4 card-user-image-container">
                <div
                  className="card-img"
                  style={{
                    backgroundImage: `url("${s3AwsEndpoint}/${props.placePhoto}")`,
                  }}
                ></div>
              </div>
              <div className="col-8 ml-3">
                <div className="card-location">
                  <h5 className="card-title card-user-title m-0">
                    <Link
                      to={{
                        pathname: `/place/${props.id}`,
                        search: `?startDate=${startDateSelected}&endDate=${endDateSelected}`,
                        state: {
                          filters: props.filters,
                        },
                      }}
                    >
                      {`${props.hostname}'s place`}
                    </Link>
                  </h5>
                  <p className="font-size-16 m-0">
                    <img src="/images/icons/location.svg" alt="" />{' '}
                    {props.location}
                  </p>
                </div>
              </div>
            </Fragment>
          )}
        </div>
        <div className="no-gutters">
          <p className="font-size-14">{props.description}</p>
          <Link
            to={{
              pathname: `/place/${props.id}?startDate=${startDateSelected}&endDate=${endDateSelected}`,
              state: { filters: props.filters },
            }}
          >
            <button type="button" className="btn btn-orange font-size-14">
              View place
            </button>
          </Link>
        </div>
      </div>
    </div>
  )
}

const ResultUserCard = (props) => {
  return (
    <div className="card card-user mb-3 mx-3 pb-3">
      <div className="card-body">
        <div className="d-flex-custom no-gutters">
          <div className="col-6 card-user-image-container">
            <div className="card-img-box">
              {/*
                                  props.auth ?
                                      <img src={s3AwsEndpoint+'/'+props.userPhoto} onError={(e)=>{e.target.onError = null; e.target.src = "/images/listing/profile-coming-soon.png"}}/>
                                      :
                                      <img src={"/images/listing/default-profile.png"}/>
                                  */}
              <img
                src={s3AwsEndpoint + '/' + props.userPhoto}
                onError={(e) => {
                  e.target.onError = null
                  e.target.src = '/images/listing/profile-coming-soon.png'
                }}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="card-location">
              <h5 className="card-title card-user-title m-0">
                <Link to={`/user/${props.id}`} className="font-size-20">
                  {props.userName}
                </Link>
              </h5>
              <p className="font-size-16 m-0">
                <img src="/images/icons/location.svg" alt="" /> {props.location}
              </p>
              {props.isHost ? (
                <span className="badge i-am-a-host">
                  <img src="/images/icons/i-am-a-host.svg" alt="" /> I’m a host
                </span>
              ) : (
                <span className="badge i-am-a-local">
                  <img src="/images/icons/example-profile.svg" alt="" /> I’m a
                  local
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="no-gutters">
          <p className="font-size-14">{props.introduction}</p>
          <Link to={`/user/${props.id}`}>
            <button type="button" className="btn btn-orange font-size-14">
              View profile
            </button>
          </Link>
        </div>
      </div>
    </div>
  )
}
const ResultsPagination = (props) => {
  const { pagination } = props

  if (props.loading) {
    return (
      <div className="col-sm-12 pt-5" style={{ textAlign: 'center' }}>
        <div className="clearfix">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    )
  }

  if (pagination.total == 0 || !pagination.total) {
    return (
      <div className="col-sm-12 pt-5">
        <p>{decode(props.listingsData[17])}</p>
      </div>
    )
  }

  const search = window.location.search
  const params = new URLSearchParams(search)
  const obj = paramsToObject(params)
  if (obj.page) {
    delete obj.page
  }
  let queryString = objectToQueryString(obj)

  if (queryString) {
    queryString = `/search?${queryString}&page=`
  } else {
    queryString = `/search?page=`
  }

  let pages = []
  let fromPage = null
  let toPage = null
  if (pagination.last_page <= 5) {
    fromPage = 1
    toPage = pagination.last_page
  } else {
    if (pagination.current_page == 1 || pagination.current_page == 2) {
      fromPage = 1
      toPage = 5
    } else if (
      pagination.current_page == pagination.last_page ||
      pagination.current_page == pagination.last_page - 1 ||
      pagination.last_page <= pagination.current_page
    ) {
      fromPage = pagination.last_page - 5
      toPage = pagination.last_page
    } else {
      fromPage = pagination.current_page - 2
      toPage = pagination.current_page + 2
    }
  }

  for (let i = fromPage; i <= toPage; i++) {
    pages.push(
      <li
        className={`page-item ${i == pagination.current_page ? 'active' : ''}`}
        key={i}
      >
        <Link className="page-link active" to={`${queryString}${i}`}>
          {i}
        </Link>
      </li>
    )
  }

  return (
    <div className="col-sm-12">
      <nav aria-label="Page navigation">
        <ul className="pagination">
          {pagination.current_page != 1 ? (
            <li className="page-item">
              <Link
                className="page-link"
                to={`${queryString}${pagination.current_page - 1}`}
                aria-label="Previous"
              >
                <span aria-hidden="true">
                  <i className="fa fa-angle-left" />
                </span>
                <span className="sr-only">Previous</span>
              </Link>
            </li>
          ) : (
            <li className="page-item d-none">
              <a className="page-link" href="#" aria-label="Previous">
                <span aria-hidden="true">
                  <i className="fa fa-angle-left" />
                </span>
                <span className="sr-only">Previous</span>
              </a>
            </li>
          )}
          {pages}
          {pagination.last_page != pagination.current_page ? (
            <li className="page-item">
              <Link
                className="page-link"
                to={`${queryString}${pagination.current_page + 1}`}
                aria-label="Next"
              >
                <span aria-hidden="true">
                  <i className="fa fa-angle-right" />
                </span>
                <span className="sr-only">Next</span>
              </Link>
            </li>
          ) : (
            <li className="page-item d-none">
              <a className="page-link" href="#" aria-label="Next">
                <span aria-hidden="true">
                  <i className="fa fa-angle-right" />
                </span>
                <span className="sr-only">Next</span>
              </a>
            </li>
          )}
        </ul>
      </nav>
    </div>
  )
}

export default withSearch(withAuth(Listings))
